import React from 'react';
import './splash-text.css';

export default function SplashText() {
  return (
    <>
      <p className="splash-text">
        Benjamin Compass Control is a software and hardware platform that
        provides the grower with complete visibility and control over their
        entire crop. Within Compass Control, Benjamin Smart Power offers energy
        monitoring solutions for indoor agricultural growing operations. Over
        the last 100 years, the science of growing has evolved so much yet the
        power distribution system remains the same. We will enhance your growing
        conditions through intelligent power distribution monitoring and
        controls.
      </p>
      <p className="splash-text splash-text-2">
        Benjamin Smart Power for the agricultural community was created as an
        extension to our extensive product line which has been implemented
        throughout the commercial/industrial lighting control market as well as
        the entertainment lighting world. Benjamin Smart Power is a pioneer
        throughout these industries - and now it is available to you!
      </p>
      <p className="splash-text splash-text-2">
        Benjamin Smart Power utilizes power and energy information to help make
        better decisions. Power is one of the largest commodities of the growing
        environment so it just makes sense to implement these details to better
        optimize this environment.
      </p>
    </>
  );
}
